import styled, { css, keyframes } from 'styled-components';
import media from 'styled-media-query';

export const FormContent = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.surface};
  `}

  padding: 2rem 4rem;
  position: relative;

  ${media.greaterThan('small')`
    border-radius: 1.5rem 1.5rem 0 0;
  `}
`;

export const LoadingWrapper = styled.div`
  width: 100vw;
  height: 100vh;

  ${({ theme }) => css`
    background-color: ${theme.colors.surface};
  `}

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.greaterThan('small')`
    max-width: 45rem;
    height: 70rem;

    border-radius: 1.5rem;
  `}
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingContent = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;

  > div {
    width: auto !important;
    height: auto !important;
  }

  ${({ theme }) => css`
    > svg {
      color: ${theme.colors.highContrast};
      animation: ${spin} 1s linear infinite;
    }
  `}
`;
